import ko from 'knockout'
import Base from '../../core/base'
const FIELDIDAFFIX = '_year_input'
class YearPicker extends Base {
  initialize (params) {
    this.data = params.data
    this.year = ko.observable(this.data() || new Date().getFullYear())
    this.fieldid = (params.fieldid || this.data._fieldid || '') + FIELDIDAFFIX
    this.disabled = params.disabled
    this.placeholder = params.placeholder
    if (!ko.isObservable(params.disabled)) {
      this.disabled = ko.observable(params.disabled)
    }
    this.isPopup = ko.observable(false)
  }
  subscribe (params) {
    this.data.subscribe(val => {
      this.year(val)
    })
  }
  methods (params) {
    this.maskClick = () => {
      this.isPopup(false)
    }
    this.showyear = () => {
    }
    this.focus = () => {
      this.isPopup(true)
    }
    this.onOk = () => {
      var _data = this.year()
      if (ko.isObservable(this.data)) {
        this.data(Number(_data))
      }
      this.isPopup(false)
    }
  }
}

export default YearPicker



// WEBPACK FOOTER //
// ./src/components/datepicker/year.js